import * as React from "react";
import type { SVGProps } from "react";
const SvgKey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 35 35"
    {...props}
  >
    <path
      fill="#14B160"
      d="M30.84 4.161a12.5 12.5 0 0 0-20.729 12.71L1.483 25.5a2.48 2.48 0 0 0-.733 1.767v4.483a2.5 2.5 0 0 0 2.5 2.5h5A1.25 1.25 0 0 0 9.5 33v-2.5H12a1.25 1.25 0 0 0 1.25-1.25v-2.5h2.5a1.25 1.25 0 0 0 .884-.366l1.494-1.495c1.25.407 2.557.613 3.872.611h.016a12.5 12.5 0 0 0 8.823-21.339M32 13.328c-.17 5.327-4.648 9.666-9.983 9.672H22a10 10 0 0 1-3.695-.705 1.25 1.25 0 0 0-1.381.263l-1.691 1.692H12a1.25 1.25 0 0 0-1.25 1.25V28h-2.5A1.25 1.25 0 0 0 7 29.25v2.5H3.25v-4.483l9.192-9.19a1.25 1.25 0 0 0 .263-1.382A10 10 0 0 1 12 12.988c0-5.335 4.345-9.813 9.672-9.983A10 10 0 0 1 32 13.328m-5-3.453a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0"
    />
  </svg>
);
export default SvgKey;
